function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M1.9,1h16.2c0.4,0,0.8,0.3,0.9,0.8l0,0.1v16.2c0,0.4-0.4,0.8-0.8,0.9l-0.1,0H1.9 c-0.5,0-0.8-0.4-0.9-0.8l0-0.1V1.9C1,1.4,1.3,1.1,1.8,1L1.9,1h16.2H1.9z M17,3H3v14h14V3z M13,10c1.1,0,2,0.9,2,2s-0.9,2-2,2 s-2-0.9-2-2S11.9,10,13,10z M13,7l-4,7H7l4-7H13z M7,7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S5.9,7,7,7z"
});

var SvgManualDiscount = function SvgManualDiscount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManualDiscount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manual_discount.f4c13857.svg";
export { ForwardRef as ReactComponent };